import type { operations } from '@multaqa/api-client'
import { api } from '@/lib/api'

export type ProductIndexParams = operations['product.index']['parameters']['query'] & {
  search?: string
}

export type ProductCategoryIndexParams =
  operations['productCategory.index']['parameters']['query'] & {
    tree?: boolean
    search?: string
  }

/**
 * Query keys for the products and product-categories features, shared so a
 * mutation in one invalidates the other's cached lists too. They live here —
 * not inside either feature — because the two features cross-invalidate each
 * other and a feature never imports from another feature (apps/company/AGENTS.md).
 */
export const productKeys = {
  all: ['products'] as const,
  lists: () => [...productKeys.all, 'list'] as const,
  list: (params?: ProductIndexParams) => [...productKeys.lists(), params] as const,
  details: () => [...productKeys.all, 'detail'] as const,
  detail: (id: string) => [...productKeys.details(), id] as const,
}

export const categoryKeys = {
  all: ['product-categories'] as const,
  lists: () => [...categoryKeys.all, 'list'] as const,
  list: (params?: ProductCategoryIndexParams) => [...categoryKeys.lists(), params] as const,
  trees: () => [...categoryKeys.all, 'tree'] as const,
  tree: (params?: ProductCategoryIndexParams) => [...categoryKeys.trees(), params] as const,
  details: () => [...categoryKeys.all, 'detail'] as const,
  detail: (id: string) => [...categoryKeys.details(), id] as const,
}

export async function fetchProductCategories(params?: ProductCategoryIndexParams) {
  const response = await api.GET('/directory/categories', {
    params: {
      query: params,
    },
  })
  return response.data?.data
}
